import axios from "axios";
import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { baseUrl, userName, ipAddress } from "./Univ.js";

function AddVolunteer() {
  const [booths, setBooths] = useState([]);
  const [rows, setRows] = useState([]);

  const [form, setForm] = useState({
    booth: "",
    name: "",
    mobile: "",
    role: "",
  });

  // ---------------- FETCH DATA ----------------
  const fetchBooths = () => {
    axios.get(baseUrl + "booths/").then(r => setBooths(r.data));
  };

  const fetchVolunteers = () => {
    axios.get(baseUrl + "volunteers/").then(r => setRows(r.data));
  };

  useEffect(() => {
    fetchBooths();
    fetchVolunteers();
  }, []);

  // ---------------- SUBMIT ----------------
  const formSubmit = () => {
    const _formData = new FormData();
    _formData.append("booth", form.booth);
    _formData.append("name", form.name);
    _formData.append("mobile", form.mobile);
    _formData.append("role", form.role);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);

    axios.post(baseUrl + "volunteers/", _formData)
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            title: "Volunteer Added",
            icon: "success",
            timer: 2000,
            showConfirmButton: false
          });
          setTimeout(() => window.location.reload(), 1000);
        }
      })
      .catch(err => console.log(err));
  };

  // ---------------- DELETE ----------------
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This volunteer will be deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Delete"
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "delete-volunteers/" + id + "/")
          .then(() => {
            Swal.fire("Deleted!", "", "success");
            fetchVolunteers();
          });
      }
    });
  };

  // ---------------- DATAGRID ----------------
const columns = [
  { field: "id", headerName: "ID", width: 70 },

  { field: "name", headerName: "Name", width: 180 },

  { field: "mobile", headerName: "Mobile", width: 150 },

  { field: "role", headerName: "Role", width: 150 },

  {
    field: "booth",
    headerName: "Booth",
    width: 120,
    renderCell: (params) => (
      <span>
        {params.value?.booth_number || params.value || "-"}
      </span>
    )
  },

  {
    field: "actions",
    headerName: "Actions",
    width: 120,
    sortable: false,
    renderCell: (params) => (
      <button
        className="btn btn-sm btn-danger"
        onClick={() => handleDelete(params.row.id)}
      >
        Delete
      </button>
    )
  }
];

  return (
    <section className="container mt-4">

  {/* ===== FORM CARD ===== */}
  <div className="card">
    <h4 className="card-header">Add Volunteer</h4>

    <div className="card-body">

      <select
        className="form-control mb-3"
        value={form.booth}
        onChange={e => setForm({ ...form, booth: e.target.value })}
      >
        <option value="">-- Select Booth --</option>
        {booths.map(b => (
          <option key={b.id} value={b.id}>
            Booth {b.booth_number}
          </option>
        ))}
      </select>

      <input
        className="form-control mb-3"
        placeholder="Volunteer Name"
        value={form.name}
        onChange={e => setForm({ ...form, name: e.target.value })}
      />

      <input
        className="form-control mb-3"
        placeholder="Mobile Number"
        value={form.mobile}
        onChange={e => setForm({ ...form, mobile: e.target.value })}
      />

      <input
        className="form-control mb-3"
        placeholder="Role"
        value={form.role}
        onChange={e => setForm({ ...form, role: e.target.value })}
      />

      <button className="btn btn-primary" onClick={formSubmit}>
        Save Volunteer
      </button>

    </div>
  </div>

  {/* ===== DATA GRID ===== */}
  <div className="mt-4">
    <DataGrid
      rows={rows}
      columns={columns}
      autoHeight
      pageSize={25}
      rowsPerPageOptions={[25, 50, 100]}
      components={{ Toolbar: GridToolbar }}
      sx={{
        boxShadow: 4,
        border: 4,
        borderColor: "primary.light",
        "& .MuiDataGrid-cell:hover": {
          color: "primary.main",
        },
      }}
    />
  </div>

</section>

  );
}

export default AddVolunteer;
